import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, HelpCircle } from "lucide-react";
/**
 * A small pill marking a cited authority/precedent/clause as verified
 * against the underlying record, rather than merely referenced in text.
 */
export function CitationChip({ label, verified = true, className = "" }) {
    return (_jsxs("span", { className: [
            "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs font-medium",
            verified
                ? "border-emerald-200 bg-emerald-50 text-emerald-800"
                : "border-amber-200 bg-amber-50 text-amber-800",
            className,
        ].join(" "), children: [verified ? _jsx(Check, { className: "h-3 w-3", "aria-hidden": true }) : _jsx(HelpCircle, { className: "h-3 w-3", "aria-hidden": true }), label] }));
}
